import createApi from './http'

export default () => createApi('api')
